import React, {useState} from 'react'
import { confirmAlert } from "react-confirm-alert";
import { connect } from "react-redux";
import {Button, Col, FormGroup, Input, Row} from "reactstrap";

// components
import { wishlistStatus } from "../../../util/WishlistUtils";

// labels
import {
    ARE_YOU_SHURE_CONFIRM_MSG,
    LB_CONFIRMED, LB_PROCESS,
    LB_PROCESSING, LB_REJECT,
    LB_REJECTED, NO, YES_CONFIRM,
    ARE_YOU_SHURE_TITLE, LB_CONFIRM,
    ARE_YOU_SHURE_REJECT_MSG,
    ARE_YOU_SHURE_PROCESS_MSG, LB_HAVE_CONFIRMATION_NUMBER, LB_COMMENTS,
} from "../../i18n/i18n";

// actions
import { setItem } from "../../../redux/actions/generalActions/formActions";
import { add } from "../../../redux/actions/todoFluye/wishlistActions";
import ModalConfirmationCode from "./ModalConfirmationCode";

const WishlistButtons = props => {
    const fbDataBase = props.mainState?.app?.fbDataBase?.id
    const { wishlist, component, style='', from='', enabledConfirmation= true, pickupHour=null } = props
    const { id, type } = component || {}

    const [showConfirmationCodeModal, setShowConfirmationCodeModal] = useState(false)

    const handleToggleModal = () => setShowConfirmationCodeModal(!showConfirmationCodeModal);


    const setConfirmationCode = confirmationCode => {
        setShowConfirmationCodeModal(!showConfirmationCodeModal);
        changeStatus(wishlistStatus.confirmed.description, confirmationCode)
    }


    const changeStatus = (status, confirmationCode) => {
        const dataRequest = {
            fbDataBase,
            item: {
                type,
                wishlist: { id: wishlist?.id },
                id,
                status,
                from,
                confirmationCode,
                pickupHour
            }
        }


        return confirmAlert({
            closeOnEscape: true,
            closeOnClickOutside: true,
            customUI: ({onClose}) => <div className='custom-ui'>
                <h1>{ARE_YOU_SHURE_TITLE}</h1>
                <p>
                    { status === wishlistStatus.confirmed.description && ARE_YOU_SHURE_CONFIRM_MSG }
                    { status === wishlistStatus.rejected.description && ARE_YOU_SHURE_REJECT_MSG }
                    { status === wishlistStatus.processing.description && ARE_YOU_SHURE_PROCESS_MSG }
                </p>
                <button onClick={onClose}>{NO}</button>
                <button className={"btn-alert-delete"} onClick={() => {
                    props.add(dataRequest);
                    onClose();
                }}>
                    {YES_CONFIRM}
                </button>
            </div>
        });
    }

    /*const handleEdit = () => {
        props.setItem(component)
        props.showModal()
    }*/

    return <>
        <div className={`wl-card-buttons-container fex-space-around mt-2em ${style}`}>
            {
                (component?.status || true) === wishlistStatus.rejected.description
                    ? <div className={'wl-card-button fex-center'} type='reject'>
                        <i className={'fa fa-times-circle'} aria-hidden='true'/> &nbsp; {LB_REJECTED}
                    </div>
                    : <Button className={'wl-label-title'} color={'link'}
                              onClick={() => changeStatus(wishlistStatus.rejected.description)}>
                        {LB_REJECT}
                    </Button>
            }

            {
                (component?.status || true) === wishlistStatus.processing.description
                    ? <div className={'wl-card-button fex-center'} type='process'>
                        <i className={'fa fa-info-circle'} aria-hidden='true'/> &nbsp; {LB_PROCESSING}
                    </div>
                    : <Button className={'wl-label-title'} color={'link'}
                              onClick={() => changeStatus(wishlistStatus.processing.description)}>
                        {LB_PROCESS}
                    </Button>
            }

            {
                (component?.status || true) === wishlistStatus.confirmed.description
                    ? <div className={'wl-card-button fex-center'} type='confirm'>
                        <i className={'fa fa-check-circle'} aria-hidden='true'/> &nbsp; {LB_CONFIRMED}
                    </div>
                    : <Button
                            className={'wl-label-title'}
                            color={'link'}
                            onClick={() => handleToggleModal()} disabled={!enabledConfirmation}
                    >
                        {LB_CONFIRM}
                    </Button>
            }
        </div>

        <ModalConfirmationCode
            handleToggle = { handleToggleModal }
            isOpen = { showConfirmationCodeModal }
            setExternalData={ setConfirmationCode }
        />
    </>
}


const mapStateToProps = state => ({
    mainState: state.mainProps
})

const mapActionsToProps = ({ setItem, add })

export default connect(mapStateToProps, mapActionsToProps)(WishlistButtons)